<template>
  <div class="card">
    <h3>Cross Reference</h3>
    <ul>
      <li v-for="(r, i) in items" :key="i">
        <strong>{{ r.identifierTypeName }}</strong>
        : {{ r.identifierTypeValue }}
      </li>
      <li v-if="items.length===0" class="empty">No cross references</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'CrossReference',
  props: { items: { type: Array, default: () => [] } },
};
</script>

<style scoped>
.card { padding: 12px; border-bottom: 1px solid #eee }
h3 { margin: 0 0 8px 0; font-size: 16px }
ul { margin: 0; padding-left: 16px }
li { padding: 4px 0 }
.empty { color:#777 }
</style>
